export default "__VITE_ASSET__51173787__"